import { modules } from '@veritone/glc-redux';

const { auth: authModule, config: configModule } = modules;

export interface GraphQLConfig {
  apiRoot: string;
  graphQLEndpoint: string;
  veritoneAppId: string;
}

export function selectToken(state: any): string {
  return (
    authModule.selectOAuthToken(state) ||
    authModule.selectSessionToken(state) ||
    ''
  );
}

export function selectGraphQLConfig(state: any): GraphQLConfig {
  const cfg = configModule.getConfig(state) as Partial<GraphQLConfig>;
  return {
    apiRoot: cfg.apiRoot ?? '',
    graphQLEndpoint: cfg.graphQLEndpoint ?? '',
    veritoneAppId: cfg.veritoneAppId ?? '',
  };
}
